import { ref, computed } from "vue";
import { defineStore } from "pinia";

export interface AppConfig {
  signInUrl: string;
  mainApiUrl: string;
  messaging: {
    enabled: boolean;
    targetOrigin?: string;
  };
  links: {
    dataRetentionPolicy: string;
    archivedLicensesLearnMore?: string;
    migrator?: string;
  };
}

export const useAppConfigStore = defineStore("appConfig", () => {
  const configFilePath = import.meta.env["VITE_APP_CONFIG_PATH"];

  const appConfig = ref(getDefaultValues());

  async function refreshConfig() {
    try {
      const response = await fetch(configFilePath);
      const configContent = await response.json() as AppConfig;
      replaceValuesWhenNotNull(appConfig.value, configContent);
      return true;
    }
    catch (exception) {
      console.warn(`Error loading config from ${configFilePath}\nException: ${exception}`);
      return true;
    }
  }

  function getDefaultValues(): AppConfig {
    return {
      signInUrl: import.meta.env['VITE_SIGN_IN_URL'] as string,
      mainApiUrl: import.meta.env['VITE_API_URL'] as string,
      messaging: {
        enabled: import.meta.env['VITE_MESSAGING_ENABLED'] as boolean,
        targetOrigin: import.meta.env['VITE_MESSAGING_TARGET_ORIGIN'] as string
      },
      links: {
        dataRetentionPolicy: import.meta.env['VITE_LINK_DATA_RETENTION_POLICY'] as string,
        archivedLicensesLearnMore: import.meta.env['VITE_LINK_ARCHIVED_LICENSES_LEARN_MORE'] as string,
        migrator: import.meta.env['VITE_LINK_MIGATOR'] as string,
      }
    };
  }

  function replaceValuesWhenNotNull(target: { [key: string]: any }, source: { [key: string]: any }) {
    for (const key in target) {
      if (source == null || source[key] == null)
        continue;

      if (typeof target[key] === "object") {
        replaceValuesWhenNotNull(target[key], source[key]);
        continue;
      }
      target[key] = source[key];
    }
  }

  return {
    appConfig: computed(() => appConfig.value),
    refreshConfig
  };
});
